import { IMotTaxStatus } from '../interfaces/mot-tax-status';
import moment from 'moment';

export function CheckMotTax(vehicle): IMotTaxStatus {
  let motTaxStatus: IMotTaxStatus = {};

  if (vehicle.taxStatus != null && vehicle.taxStatus.toLowerCase() == 'taxed') {
    motTaxStatus.isTaxValid = true;
  }

  let noMotNeededStatus = 'no results returned';
  let noDetailsStatus = 'no details held by dvla';
  let motStatus = vehicle.motStatus != null ? vehicle.motStatus.toLowerCase() : null;

  if (vehicle.motStatus != null && (motStatus == 'valid' || motStatus == noMotNeededStatus)) {
    motTaxStatus.isMotValid = true;
  } else {
    motTaxStatus.isMotValid = false;
  }

  const threeYearsAgo = moment().subtract(3, 'years');

  motTaxStatus.motNotRequired =
    (motStatus == noMotNeededStatus || motStatus == noDetailsStatus) &&
    threeYearsAgo.isBefore(vehicle.registrationDate);

  if (motTaxStatus.motNotRequired) {
    motTaxStatus.isMotValid = true;
  }

  motTaxStatus.isTaxMotFound = true;

  if (
    vehicle.taxStatus == null ||
    vehicle.motStatus == null ||
    vehicle.taxStatus == '' ||
    vehicle.motStatus == ''
  ) {
    motTaxStatus.isTaxMotFound = false;
  }

  return motTaxStatus;
}
